<!--Main Navigation-->
<header>
  <!-- Sidebar -->

  <div class="side-nav fixed wide" #sidenav style="background-color: white">
    <ul>
      <!-- Logo -->
      <li>
        <a #logoLarge class="logo-wrapper waves-effect p-1" s href="/broker-account">
          <img src="../../../../assets/img/Trakly_Logo.png" class="img-fluid py-0" alt="" height="48px" />
        </a>
        <a #logoSmall class="waves-effect p-1 d-none" href="/broker-account">
          <img src="../../../../assets/img/Trakly_Icon.png" class="img-fluid" alt="" />
        </a>
      </li>
      <!--/. Logo -->
      <!-- Side navigation links -->
      <li>
        <ul class="collapsible collapsible-accordion">
          <!-- <li>
                        <a routerLink="dashboard" routerLinkActive="active" (click)="menuClicked()"
                            class="list-group-item border border-0 list-group-item-action waves-effect">
                            <mdb-icon fas icon="home" class="mr-3"></mdb-icon>Home
                        </a>
                    </li>-->
          <li>
            <a
              routerLink="user-management"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="users" class="mr-3"></mdb-icon>User Management
            </a>
          </li>
          <li>
            <a
              routerLink="trade-planning"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fa fa-calendar-alt" class="mr-3"></mdb-icon>Trade Planning
            </a>
          </li>
          <li>
            <a
              routerLink="current-trades"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fa fa-chart-column" class="mr-3"></mdb-icon>Current Trades
            </a>
          </li>
          <li>
            <a
              routerLink="trade-docs"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fa fa-copy" class="mr-3"></mdb-icon>Trade Docs
            </a>
          </li>
          <li>
            <a
              routerLink="ait"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fa fa-file-invoice" class="mr-3"></mdb-icon>AIT Management
            </a>
          </li>
          <li>
            <a
              routerLink="onboarding"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fas fa-plane" class="mr-3"></mdb-icon>Onboarding
            </a>
          </li>
          <li>
            <a
              routerLink="wealth-onboarding"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fas fa-gem" class="mr-3"></mdb-icon>Wealth Onboarding
            </a>
          </li>
          <li>
            <a
              routerLink="offboarding"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fas fa-plane-departure" class="mr-3"></mdb-icon>Offboarding
            </a>
          </li>
          <li>
            <a
              routerLink="tools"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fas fa-screwdriver-wrench" class="mr-3"></mdb-icon>Tools
            </a>
          </li>
          <li>
            <a
              routerLink="tools/public-holidays"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fas fa-calendar-days" class="mr-3"></mdb-icon>Public Holidays
            </a>
          </li>
          <li>
            <a
              routerLink="/sql-reports"
              routerLinkActive="active"
              (click)="menuClicked()"
              class="list-group-item border border-0 list-group-item-action waves-effect"
            >
              <mdb-icon fas icon="fa fa-file-csv" class="mr-3"></mdb-icon>Reporting
            </a>
          </li>
          <li>
            <a class="list-group-item border border-0 list-group-item-action waves-effect" (click)="toggleSideNav()">
              <i #minimiseMenuBtn class="sv-slim-icon fas fa-angle-double-left"></i>Minimize menu
            </a>
          </li>
        </ul>
      </li>
      <!--/. Side navigation links -->
    </ul>
  </div>
  <!--/. Sidebar navigation -->
  <!-- Sidebar -->

  <!--Navbar-->
  <mdb-navbar [containerInside]="false" SideClass="navbar navbar-expand navbar-expand-xs navbar-light trakly1 pr-0 nav-height">
    <div
      id="settingsTitle"
      [ngStyle]="{
        'padding-left': settingsService.sidenavExpanded ? '240px' : '48px'
      }"
      class="mx-lg-5 nav-height"
      style="padding-top: 7px !important"
    >
      <h4 *ngIf="showTextInHeader">
        <b>{{ headerText }}</b>
      </h4>
    </div>
    <!-- Collapsible content -->
    <links class="nav-height" style="padding-top: 7px !important; padding-bottom: 7px">
      <!-- Search form -->
      <ul class="navbar-nav nav-flex-icons ml-auto align-items-center" *ngIf="showNav">
        <li class="nav-item">
          <div class="btn-group" mdbDropdown>
            <a mdbDropdownToggle type="button" class="dropdown-toggle nav-link pt-0 pb-0" data-mdb-auto-close="false" aria-expanded="false">
              Balance Update
            </a>
            <div
              class="dropdown-menu dropdown-primary dropdown-menu-right py-0"
              style="min-width: 20rem !important; z-index: 1025"
              (click)="$event.stopPropagation()"
            >
              <mdb-card>
                <mdb-card-body>
                  <app-progress-report></app-progress-report>
                </mdb-card-body>
              </mdb-card>
            </div>
          </div>
        </li>
        <li class="nav-item" *ngIf="settingsService.userProfile">
          <div class="btn-group" mdbDropdown>
            <a mdbDropdownToggle type="button" class="dropdown-toggle nav-link pt-0 pb-0" mdbWavesEffect>
              <img
                src="../../../assets/img/profilePictures/{{ settingsService.userProfile.avatarId }}.png"
                alt="Avatar"
                class="md-avatar rounded-circle"
              />
            </a>
            <div class="dropdown-menu dropdown-primary dropdown-menu-right py-0" style="min-width: 20rem !important; z-index: 1025">
              <mdb-card class="">
                <!--Bacground color-->
                <div class="card-up indigo lighten-1"></div>

                <!--Avatar-->
                <div class="avatar mx-auto pt-2">
                  <img
                    src="../../../assets/img/profilePictures/{{ settingsService.userProfile.avatarId }}.png"
                    class="rounded-circle"
                    style="max-width: 100px"
                  />
                </div>

                <mdb-card-body>
                  <!--Name-->
                  <mdb-card-title class="text-center">
                    <h4>{{ settingsService.userProfile.fullName }}</h4>
                    <h6>
                      <small>{{ settingsService.user?.email }}</small>
                    </h6>
                  </mdb-card-title>
                  <a class="dropdown-item border border-right-0 border-left-0" routerLink="settings">Settings</a>
                  <a class="dropdown-item" (click)="Logout()">Sign out</a>
                </mdb-card-body>
              </mdb-card>
            </div>
          </div>
        </li>
      </ul>
    </links>
    <!-- Collapsible content -->
  </mdb-navbar>
  <!--/.Navbar-->
  <div
    *ngIf="environmentBanner"
    class="trakly-env-banner"
    [class.trakly-env-banner--production]="isProductionBanner"
    role="status"
  >
    {{ environmentBanner }}
  </div>
</header>
<!--Main Navigation-->
